(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  // --- Scroll behavior: compact header on scroll, keep search/menu always visible ---
  (function() {
    const headerEl = document.querySelector('.header');
    if (!headerEl) return;

    // Hysteresis so it doesn't flicker around the threshold
    const COMPACT_ON  = 120; // px
    const COMPACT_OFF = 60;  // px

    let compact = false;
    let ticking = false;

    function apply(y) {
      // Compact header (logo scale + tighter padding) on mobile + desktop
      if (!compact && y > COMPACT_ON) {
        compact = true;
        headerEl.classList.add('header--compact');
      } else if (compact && y < COMPACT_OFF) {
        compact = false;
        headerEl.classList.remove('header--compact');
      }
      // NOTE: no header--scrolled class, so search + menu never hide.
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        apply(window.scrollY || window.pageYOffset || 0);
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll(); // initial state on load
  })();

document.addEventListener('click', (e) => {
  const a = e.target.closest('a[href]');
  if (!a) return;

  const href = a.getAttribute('href') || '';
  const isAccount =
    href.includes('/account') ||
    href === (window.Shopify && Shopify.routes && Shopify.routes.account) ||
    href === (window.Shopify && Shopify.routes && Shopify.routes.account_login);

  if (!isAccount) return;

  a.setAttribute('target', '_self');
}, true);


  } catch(e) { console.error(e); }
})();
})();
